import { Row,Col} from "reactstrap"
import { LabelText } from "../Utils/Input"

export const CustomerDetailsInViewCancel = ({isView,isCancel,CustomerName,orderDataById,CustomerId}) => {
    return (
        <div>

        <h6 className="fs-16 fw-semibold mb-3">Customer Details</h6>
                <Row>
                    <Col xl={12} className="mb-3">
                        <LabelText className="fs-14 fw-bold" displayText={"Customer Name"} />
                        <p className="rv-label-muted my-2 fs-14">{!(isView || isCancel) ? CustomerName :
                            (orderDataById && orderDataById.relatedParty && orderDataById.relatedParty[0] && orderDataById.relatedParty[0].partyOrPartyRole && orderDataById.relatedParty[0].partyOrPartyRole.name
                                ? orderDataById.relatedParty[0].partyOrPartyRole.name
                                : "NA")}</p>
                    </Col>
                    <Col xs={12} className="mb-3">
                        <LabelText className="fs-14 fw-bold" displayText={"Account Details"} />
                        <p className="rv-label-muted my-2 fs-14">{(isView || isCancel) && orderDataById && orderDataById.relatedParty && orderDataById.relatedParty[0] && orderDataById.relatedParty[0].partyOrPartyRole
                            ? orderDataById.relatedParty[0].partyOrPartyRole.id
                            : CustomerId}</p>
                    </Col>
                </Row>
         </div>
    )
}